import AuthLeftPanel from "../components/AuthLeftPanel";
import { useOtpViewModel } from "../../viewmodels/useOtpViewModel";
import { useState } from "react";
import { styles as s } from "../../styles/signupstyles";
import { otp } from "../../styles/otpStyles";
import NeedHelpModal from "../components/NeedHelpModal";
import OtpStatusAlert from "../components/OtpStatusAlert";
type Props = {
    method: "email" | "phone";
    destination: string;
    onBack: () => void;
};

export default function OtpVerificationScreen({
    method,
    destination,
    onBack,
}: Props) {
    const vm = useOtpViewModel(method, destination);
    const [showHelp, setShowHelp] = useState(false);

    if (vm.otpError?.blocked) {
        return (
            <div className={s.rightPanel}>
                <div className={otp.form}>
                    <button
                        type="button"
                        className={otp.backButton}
                        onClick={onBack}
                    >
                        ← Back
                    </button>

                    <OtpStatusAlert
                        variant="blocked"
                        title="Account temporarily locked"
                        message={vm.otpError.message}
                        lockSeconds={vm.retryAfterSeconds}
                        onNeedHelp={() => setShowHelp(true)}
                    />

                    {showHelp && (
                        <NeedHelpModal
                            onClose={() => setShowHelp(false)}
                        />
                    )}
                </div>
            </div>
        );
    }
    return (
        <div className={s.rightPanel}>
            <div className={otp.form}>
                {/* Back */}
                <button
                    type="button"
                    className={otp.backButton}
                    onClick={onBack}
                >
                    ← Back
                </button>

                <div className="mx-auto flex w-full max-w-[560px] flex-col">
                    <h2 className={otp.title}>Verify your {vm.method}</h2>

                    <p className={otp.subtitle}>
                        We sent a 6-digit verification code to
                    </p>

                    <p className={otp.destination}>{vm.destination}</p>

                    <button
                        type="button"
                        className={otp.editLink}
                        onClick={onBack}
                    >
                        Wrong {vm.method}? Edit
                    </button>

                    {/* OTP */}
                    <div className={otp.otpRow}>
                        {vm.otp.map((digit, index) => (
                            <input
                                key={index}
                                ref={(el) => {
                                    if (el) {
                                        vm.inputRefs.current[index] = el;
                                    }
                                }}
                                className={otp.otpInput}
                                maxLength={1}
                                value={digit}
                                inputMode="numeric"
                                onChange={(e) =>
                                    vm.handleOtpChange(index, e.target.value)
                                }
                                onKeyDown={(e) =>
                                    vm.handleKeyDown(index, e)
                                }
                            />
                        ))}
                    </div>

                    {/* Resend */}
                    <div className={otp.resendSection}>
                        {vm.otpError && (
                            <p className={otp.resendCount}>
                                {(vm.otpError.attemptsRemainingBeforeBlock ?? 0) > 0
                                    ? `${vm.otpError.attemptsRemainingBeforeBlock ?? 0} attempts remaining`
                                    : "Temporarily locked"}
                            </p>
                        )}

                        {vm.secondsRemaining > 0 ? (
                            <p className={otp.timer}>
                                Resend in {vm.secondsRemaining}s
                            </p>
                        ) : (
                            <button
                                className={otp.resendButton}
                                onClick={vm.handleResend}
                            >
                                Resend code
                            </button>
                        )}
                    </div>

                    {/* Remember Device */}
                    <label className={otp.rememberRow}>
                        <input
                            type="checkbox"
                            checked={vm.rememberDevice}
                            onChange={(e) =>
                                vm.setRememberDevice(e.target.checked)
                            }
                            className={otp.checkbox}
                        />

                        <div>
                            <p className={otp.rememberTitle}>
                                Remember this device
                            </p>

                            <p className={otp.rememberSubtitle}>
                                Skip the verification code here for the next 30 days.
                            </p>
                        </div>
                    </label>
                    {vm.otpError && (
                        <OtpStatusAlert
                            variant={
                                vm.otpError.blocked
                                    ? "blocked"
                                    : vm.otpError.message
                                        .toLowerCase()
                                        .includes("expired")
                                        ? "expired"
                                        : vm.otpError.attemptsRemainingBeforeBlock === 1
                                            ? "warning"
                                            : "incorrect"
                            }
                            title={
                                vm.otpError.blocked
                                    ? "Account temporarily locked"
                                    : vm.otpError.message
                                        .toLowerCase()
                                        .includes("expired")
                                        ? "OTP has expired"
                                        : vm.otpError.attemptsRemainingBeforeBlock === 1
                                            ? "Last attempt"
                                            : "Incorrect code"
                            }
                            message={vm.otpError.message}
                            lockSeconds={vm.retryAfterSeconds}
                            onNeedHelp={() => setShowHelp(true)}
                        />
                    )}
                    {/* Need Help */}
                    <button
                        type="button"
                        className={otp.needHelp}
                        onClick={() => setShowHelp(true)}
                    >
                        Need help?
                    </button>

                    {showHelp && (
                        <NeedHelpModal
                            onClose={() => setShowHelp(false)}
                        />
                    )}

                    {/* Verify */}
                    <button
                        disabled={!vm.isOtpComplete}
                        onClick={vm.verifyOtp}
                        className={`${otp.verifyButton} ${vm.isOtpComplete
                            ? otp.verifyActive
                            : otp.verifyDisabled
                            }`}
                    >
                        Verify
                    </button>
                </div>
            </div>
        </div>


    );
}
